import { Preferences } from "./Preferences"

export type ConsentStatus = 'granted' | 'denied'

export type ConsentState = {
  analytics_storage: ConsentStatus
  ad_storage: ConsentStatus
  ad_user_data: ConsentStatus
  ad_personalization: ConsentStatus
}

export const DEFAULT_CONSENT_STATE: ConsentState = {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
}

export function toConsentState(preferences: Pick<Preferences, 'analytics' | 'marketing'>): ConsentState {
  const analytics: ConsentStatus = preferences.analytics ? 'granted' : 'denied'
  const marketing: ConsentStatus = preferences.marketing ? 'granted' : 'denied'
  return {
    analytics_storage: analytics,
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
  }
}

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

export function gtagConsentUpdate(preferences: Pick<Preferences, 'analytics' | 'marketing'>) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('consent', 'update', toConsentState(preferences))
}
